import { render, staticRenderFns } from "./PetproductView.vue?vue&type=template&id=213d3854&scoped=true"
import script from "./PetproductView.vue?vue&type=script&lang=js"
export * from "./PetproductView.vue?vue&type=script&lang=js"
import style0 from "./PetproductView.vue?vue&type=style&index=0&id=213d3854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213d3854",
  null
  
)

export default component.exports